"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.Wrapper = exports.SortButtonStyle = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e10t3jyv0"
} : {
  target: "e10t3jyv0",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:flex;justify-self:", props.justify, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));
const styles = exports.styles = {
  beforeStyle: size => /*#__PURE__*/(0, _react.css)("&::before{content:attr(data-title);font-weight:600;font-family:'Source Sans Pro',sans-serif;font-size:", size ? size : '16px', ";margin-right:5px;display:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:beforeStyle;")),
  breakWord: process.env.NODE_ENV === "production" ? {
    name: "7zraa8",
    styles: "word-break:break-word;&>*{word-break:break-word;}"
  } : {
    name: "j7ij0c-breakWord",
    styles: "word-break:break-word;&>*{word-break:break-word;};label:breakWord;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  paddingRight: value => /*#__PURE__*/(0, _react.css)("padding-right:", value, "!important;" + (process.env.NODE_ENV === "production" ? "" : ";label:paddingRight;")),
  paddingLeft: value => /*#__PURE__*/(0, _react.css)("padding-left:", value, "!important;" + (process.env.NODE_ENV === "production" ? "" : ";label:paddingLeft;")),
  setFontSize: value => /*#__PURE__*/(0, _react.css)("font-size:", value, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:setFontSize;")),
  ellipsis: process.env.NODE_ENV === "production" ? {
    name: "1tbxv1m",
    styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;display:block"
  } : {
    name: "fiyexg-ellipsis",
    styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;display:block;label:ellipsis;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  textcenter: process.env.NODE_ENV === "production" ? {
    name: "1azakc",
    styles: "text-align:center"
  } : {
    name: "vuttib-textcenter",
    styles: "text-align:center;label:textcenter;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
const SortButtonStyle = exports.SortButtonStyle = process.env.NODE_ENV === "production" ? {
  name: "dw9y0j",
  styles: "&>span{font-weight:600;opacity:0.5;}"
} : {
  name: "1w1k47i-SortButtonStyle",
  styles: "&>span{font-weight:600;opacity:0.5;};label:SortButtonStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};